import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'ml-result-field',
    templateUrl: './ml-result-field.component.html',
    styleUrls: ['./ml-result-field.component.css']
})
export class MlResultFieldComponent implements OnInit {

    @Input() responses!: string;
    @Input() requestRunning!: string;

    @Output() responseAccepted = new EventEmitter<any>();
    @Output() responseRejected = new EventEmitter<any>();

    resultClass: string[] = ['', '', '', '', ''];

    acceptedIndex: number = -1;

    constructor() { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.responses && changes.responses.currentValue) {
            changes.responses.currentValue.forEach((_: string, index: number) => {
                if (this.resultClass[index] == 'rejected') {
                    this.resultClass[index] = '';
                }
            });
        }
    }

    onReject(event) {
        if (this.acceptedIndex == event) {
            this.acceptedIndex = -1;
        }

        this.resultClass[event] = 'rejected';

        this.responseRejected.emit(event);
    }

    onAccept(event) {
        if (this.acceptedIndex > -1) {
            this.resultClass[this.acceptedIndex] = '';
        }

        this.acceptedIndex = event;
        this.resultClass[event] = 'accepted';

        this.responseAccepted.emit(event);
    }
}
